import { ActuContext } from 'pages/actualite/[slug]';
import { Content } from 'pleinchamp-api-client/dist/src/content/search';
import React, { useContext } from 'react';
import { useQuery } from 'react-query';
import { fetchLastActus } from '@actus/actus.api';
import { ADVERT_FORMAT_ID } from '@adverts/business/Adverts.contants';
import { GenericAd } from '@adverts/components/GenericAd.component';
import { LastContent } from '@components/content/LastContent/LastContent.component';
import { MostViewedContent } from '@components/content/MostViewedContent/MostViewedContent.component';
import { SearchContentType } from '@search/business/search.types';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { Spacing } from '@styles/Spacing.style';
import { generateLightCardFromArticle } from '@utils/card';

interface Props {
  slug?: string;
}

export function LastAndMostViewedContentWithAds({ slug }: Props) {
  const isSmartphone = useIsBreakpointDown(Breakpoint.s);
  const { mostViewedNews } = useContext(ActuContext);

  const { data, refetch, error } = useQuery<Content[], any>(['FETCH_LAST_ACTUS', slug], () => fetchLastActus(slug));

  return (
    <>
      <GenericAd
        formatId={isSmartphone ? ADVERT_FORMAT_ID.WideAngle : ADVERT_FORMAT_ID.WideAngle}
        style={{ marginBottom: Spacing.basis }}
      />
      <LastContent
        cards={(data || []).map(generateLightCardFromArticle)}
        contentType={SearchContentType.Article}
        error={error ?? undefined}
        retryCallback={refetch}
        seeAllLinkI18nKey="actu.last.see-all"
        titleI18nKey="actu.last.title"
      >
        <MostViewedContent forceColumn i18nTitle="actu.most-viewed-articles" variant="compact" {...mostViewedNews} />
      </LastContent>
    </>
  );
}
